/**
 * Commodity card piles. Drawing is the only place cards leave the face-down
 * pile, so the exhaustion rule (R-015) lives here and nowhere else.
 */
import { shuffle } from './rng.js';
/**
 * Draw up to `n` cards from the face-down pile. If it runs dry mid-draw the two
 * discard piles (minus one face-up card each) are shuffled into a new pile
 * (R-015, placeholder ruling). Returns fewer cards only when nothing is left.
 */
export function drawCards(state, n) {
    let drawPile = state.hidden.drawPile;
    let discards = state.discards;
    let rng = state.rng;
    const cards = [];
    const events = [];
    while (cards.length < n) {
        if (drawPile.length === 0) {
            const [d0, d1] = discards;
            const pool = [...d0.slice(0, -1), ...d1.slice(0, -1)];
            if (pool.length === 0)
                break;
            const [shuffled, next] = shuffle(rng, pool);
            rng = next;
            drawPile = shuffled;
            discards = [d0.slice(-1), d1.slice(-1)];
            events.push({ type: 'DrawPileReshuffled', cards: shuffled.length });
        }
        cards.push(drawPile[0]);
        drawPile = drawPile.slice(1);
    }
    return {
        state: { ...state, rng, discards, hidden: { ...state.hidden, drawPile } },
        cards,
        events,
    };
}
//# sourceMappingURL=cards.js.map